import { FC } from 'react';
import { TelegramSettings } from '../TelegramSettings';
import styles from './Settings.module.scss';

interface SettingTypes {
  title?: string;
}

export const Settings: FC<SettingTypes> = () => {
  return (
    <div className={styles.settings}>
      <TelegramSettings />
    </div>
  );
};
